import React, { useState, useEffect } from 'react'
import { MiFooter } from '../../components/footer/MiFooter';
import Header from '../../components/headers/Header';
import { ContentBodyCategoriaEmpresa } from '../../components/CategoriasEmpresa/ContentBodyCategoriaEmpresa';
import './CategoriasEmpresa.css'

export const CategoriasEmpresa = () => {

  const [MenuLateralAux, setMenuLateralAux] = useState();

  const chageMenuLateralAux = () => {
    setMenuLateralAux(!MenuLateralAux)
  }

  return (
    <div className='Presupuestos'>
      <div className='headerPresupuestos'>
        <Header
          chageMenuLateralAux={chageMenuLateralAux}
        />
      </div>
      <div className="bodyPresupuestos">
        <ContentBodyCategoriaEmpresa
          MenuLateralAux={MenuLateralAux}
          chageMenuLateralAux={chageMenuLateralAux}
        />
      </div>
      <div className='footerPresupuestos'>
        <MiFooter
        />
      </div>
    </div>
  )
}
